import { useIntl } from "react-intl";

export enum MaintenanceGroupEnum {
    RODOVIARIO = "RODOVIARIO",
    MISTO = "MISTO",
    SEVERO = "SEVERO",
    ESPECIAL = "ESPECIAL",
}

export const getMaintenanceGroupLabel = (group: string | undefined) => {
    const intl = useIntl();
    switch (group) {
        case MaintenanceGroupEnum.RODOVIARIO:
            return intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.edit.roadway" });
        case MaintenanceGroupEnum.MISTO:
            return intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.edit.mixed" });
        case MaintenanceGroupEnum.SEVERO:
            return intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.edit.severe" });
        case MaintenanceGroupEnum.ESPECIAL:
            return intl.formatMessage({ id: "intl-msg:maintenanceGroupSidebar.edit.special" });
        default:
            return group;
    }
}

export const getMaintenanceGroupLabelByValue = (group: string | undefined) => {
    switch (group) {
        case "1":
            return getMaintenanceGroupLabel(MaintenanceGroupEnum.RODOVIARIO);
        case "2":
            return getMaintenanceGroupLabel(MaintenanceGroupEnum.MISTO);
        case "3":
            return getMaintenanceGroupLabel(MaintenanceGroupEnum.SEVERO);
        case "4":
            return getMaintenanceGroupLabel(MaintenanceGroupEnum.ESPECIAL);
        default:
            return getMaintenanceGroupLabel(group);
    }
}